import { Routes } from '@angular/router';
import { AuthGuard, SIGNED_OUT_ROUTE, iconSet } from '@ascent/shared';

import { AppShellComponent } from './modules/core/app-shell/app-shell.component';
import { ForbiddenComponent } from './modules/core/forbidden/forbidden.component';
import { SignedOutComponent } from './modules/core/signed-out/signed-out.component';

// The two feature libraries are loaded lazily by their route arrays rather than by an NgModule.
// Both arrays already existed and already pointed at the components; only the thing named in the
// import changed, so the route tree itself is untouched.
export const appRoutes: Routes = [{
  // The one route outside the AuthGuard. Everything else needs a session, so returning anywhere but
  // here after signing out would immediately start a new sign-in. Registered in Cardinal as this
  // application's post logout redirect uri; the path comes from SIGNED_OUT_ROUTE so the two cannot
  // drift apart. Listed first because it has to match before the shell's empty prefix does.
  path: SIGNED_OUT_ROUTE.substring(1),
  component: SignedOutComponent
}, {
  path: '',
  canActivate: [AuthGuard],
  component: AppShellComponent,
  children: [{
    path: 'configuration',
    canActivate: [AuthGuard],
    data: {
      titleKey: 'Configuration',
      isMainNavigation: true,
      icon: iconSet.configuration,
      only: []
    },
    loadChildren: () => import('@ascent/configuration').then(m => m.ascentConfigurationRoutes)
  }, {
    path: 'settings',
    canActivate: [AuthGuard],
    data: {
      titleKey: 'Settings',
      isMainNavigation: true,
      icon: iconSet.settings,
      only: []
    },
    loadChildren: () => import('@ascent/settings').then(m => m.ascentSettingsRoutes)
  }, {
    path: '403',
    component: ForbiddenComponent
  }, {
    path: '',
    redirectTo: 'configuration',
    pathMatch: 'full'
  }]
}, {
  path: '**',
  redirectTo: '/',
  pathMatch: 'full'
}];
